// Registers a global axios request interceptor (see authTokens.js for why)
// that attaches the sessionStorage-backed Bearer token for client/admin API
// calls. Imported once at app startup — do not import per-component.
import axios from 'axios';
import { getClientToken, getAdminToken } from './authTokens';

axios.interceptors.request.use((config) => {
  const url = config.url || '';
  if (url.includes('/api/client/')) {
    const token = getClientToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } else if (url.includes('/api/admin/') || url.includes('/api/auth/')) {
    const token = getAdminToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
